import Vue from 'vue'



import {is_Empty, decodeAndSanitizeId} from "./index";

function createSafeSpan(text, className) {
    // 用于防范XSS攻击，确保text和className是安全的值
    // 这里可以使用一个库（如DOMPurify）来清理HTML，或者使用模板 literal来确保值被正确转义
    return `<span class="${className}">${text}</span>`;
}


let myMixin = {
    data() {
        return {
            HTTPS_URL: "https://api.beltdance.com/"
        }
    },
    computed: {
        generateStorageKey() {
            const path = this.$route.fullPath;
            return decodeAndSanitizeId(`${btoa(path)}-form`);
        },
    },
    methods: {
        addressInfoView1({province = '', city = '', country = '', detailed = ''}) {
            let arr = [];
            // 使用简化的条件检查，并直接利用JavaScript的truthy特性
            province && arr.push(province);
            // 确保city不为空
            province !== city && city && arr.push(city);
            country && arr.push(country);
            detailed && arr.push(detailed);
            return arr.join('')
        },

        deepClone(obj, hash = new WeakMap()) {
            // 检查 obj 是否是对象类型（排除 null、基础类型等）
            if (typeof obj !== "object" || obj === null) {
                return obj;  // 基本类型直接返回
            }

            // 防止循环引用的哈希检查
            if (hash.has(obj)) {
                return hash.get(obj);  // 返回已克隆的对象
            }

            let res = null;
            const reference = [Date, RegExp, Set, Map, Error];

            // 处理特殊的引用类型
            if (reference.includes(obj.constructor)) {
                res = new obj.constructor(obj);
            } else if (Array.isArray(obj)) {  // 处理数组
                res = [];
                hash.set(obj, res);  // 防止循环引用
                obj.forEach((e, i) => {
                    res[i] = this.deepClone(e, hash);
                });
            } else {  // 处理普通对象
                res = {};
                hash.set(obj, res);  // 防止循环引用
                for (const key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        res[key] = this.deepClone(obj[key], hash);
                    }
                }
            }

            hash.set(obj, res);  // 将当前对象及其克隆结果存入hash
            return res;
        },
        //深拷贝
        deepClone2(obj, hash = new WeakMap()) {
            if (hash.has(obj)) {
                return obj;
            }
            let res = null;
            const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error];

            if (!this.is_empty(obj.constructor) && reference.includes(obj.constructor)) {
                res = new obj.constructor(obj);
            } else if (Array.isArray(obj)) {
                res = [];
                obj.forEach((e, i) => {
                    res[i] = this.deepClone(e);
                });
            } else if (typeof obj === "Object" && obj !== null) {
                res = {};
                for (const key in obj) {
                    if (Object.hasOwnProperty.call(obj, key)) {
                        res[key] = this.deepClone(obj[key]);
                    }
                }
            } else {
                res = obj;
            }
            hash.set(obj, res);
            return res;
        },
        // 改进的深拷贝方法
        deepClone1(obj, hash = new WeakMap(), visited = new Map()) {
            // 检查循环引用
            if (visited.has(obj)) {
                return visited.get(obj);
            }

            let res = null;

            // 处理特殊对象的深拷贝
            const specialObjects = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error];
            if (specialObjects.some(constructor => obj instanceof constructor)) {
                try {
                    res = new obj.constructor(obj);
                } catch (e) {
                    console.error(`Error cloning special object of type ${obj.constructor.name}: ${e}`);
                    res = obj;  // 如果构造函数抛出错误，为了不中断执行，可以考虑保留原对象或进行其他处理
                }
            } else if (Array.isArray(obj)) {
                res = [];
                visited.set(obj, res);  // 添加到visited中以处理循环引用
                obj.forEach((item, index) => {
                    res[index] = this.deepClone(item, hash, visited);
                });
            } else if (obj instanceof Object && obj !== null) {  // 使用instanceof提升兼容性
                res = {};
                visited.set(obj, res);  // 添加到visited中以处理循环引用
                Object.keys(obj).forEach(key => {
                    if (obj.hasOwnProperty(key)) {  // 使用更直接的方式检查属性所有权
                        res[key] = this.deepClone(obj[key], hash, visited);
                    }
                });
            } else {
                res = obj;
            }

            // 保存原对象与拷贝对象的映射关系
            hash.set(obj, res);
            return res;
        },



        digitUppercase(n) {
            let fraction = ['角', '分'];
            let digit = [
                '零', '壹', '贰', '叁', '肆',
                '伍', '陆', '柒', '捌', '玖'
            ];
            let unit = [
                ['元', '万', '亿'],
                ['', '拾', '佰', '仟']
            ];
            let head = n < 0 ? '欠' : '';
            n = Math.abs(n);
            let s = '';
            for (let i = 0; i < fraction.length; i++) {
                s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
            }
            s = s || '整';
            n = Math.floor(n);
            for (let i = 0; i < unit[0].length && n > 0; i++) {
                let p = '';
                for (let j = 0; j < unit[1].length && n > 0; j++) {
                    p = digit[n % 10] + unit[1][j] + p;
                    n = Math.floor(n / 10);
                }
                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
            }
            return head + s.replace(/(零.)*零元/, '元')
                .replace(/(零.)+/g, '零')
                .replace(/^整$/, '零元整');
        },
        toDecimal2(x, length) {
            length = length || 2;
            let sum = "1";
            while (sum.length <= length) {
                sum += "0";
            }
            sum = Number(sum);
            let f = parseFloat(x);
            if (isNaN(f)) {
                return 0;
            }
            f = Math.round(x * sum) / sum;
            let s = f.toString();
            let rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + length) {
                s += '0';
            }
            return s;
        },
        strNames(text) {
            if (is_Empty(text)) return "";
            let str = text, val = "";
            for (let i = 0; i < str.length; i++) {
                const el = str[i];
                if (/[\u4e00-\u9fa5]/.test(el)) {
                    val += el;
                }

            }
            return val;
        },
        back(key, value) {
            //带参数返回上一页

            if (key && value) {
                let pages = this.$pageStack.getStack();
                let prePage = pages[pages.length - 2];
                prePage.vnode.componentInstance[key] = value;
            }
            this.$router.go(-1);
        },
        go(router) {
            this.$router.push(router)
        },
        redirect(router) {

            this.$router.replace(router);
        },

        set(key, value) {
            sessionStorage.setItem(key, JSON.stringify(value));
        },
        getItem(key) {
            return JSON.parse(sessionStorage.getItem(key))
        },
        remove(key) {
            sessionStorage.removeItem(key)
        },

        formatPhone(phone) {
            return phone.substr(0, 3) + '****' + phone.substr(7, 11);
        },
        formatBankCard(card) {
            let str = '';
            for (let i = 0; i < card.length - 7; i++) {
                str += '*'
            }
            return card.substr(0, 4) + str + card.substr(-3);
        },
        // 验证手机号
        checkPhone(phone) {
            if (this.is_empty(phone)) return false;
            if (phone.length !== 11) return false;
            return /^(1[3-9])\d{9}/.test(this.trimStr(phone));
        },
        checkEmail(value) {
            return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.trimStr(value));
        },
        // 验证统一社会信用代码
        checkTaxId(taxId) {
            return /[0-9A-Z]{18}/.test(this.trimStr(taxId));
        },
        // 验证银行卡号
        checkBack(value) {
            value = value.replace(/\s+/g, "");
            let regArr = /^([1-9]{1})(\d{15}|\d{18})$/;
            return regArr.test(value);
        },
        //去除首尾空格
        trimStr(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
        // 加
        add(a, b) {
            a = Number(a);
            b = Number(b);
            let c, d, e;
            try {
                c = a.toString().split(".")[1].length;
            } catch (f) {
                c = 0;
            }
            try {
                d = b.toString().split(".")[1].length;
            } catch (f) {
                d = 0;
            }
            return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
        },

        // 减
        sub(a, b) {
            a = Number(a);
            b = Number(b);
            let c, d, e;
            try {
                c = a.toString().split(".")[1].length;
            } catch (f) {
                c = 0;
            }
            try {
                d = b.toString().split(".")[1].length;
            } catch (f) {
                d = 0;
            }
            return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
        },
        // 乘
        mul(a, b) {
            a = Number(a);
            b = Number(b);
            let c = 0, d, e;
            // if (typeof (a) == "number") {
            try {

                d = a.toString();
            } catch (error) {

            }
            try {
                e = b.toString();
            } catch (error) {

            }
            try {
                c += d.split(".")[1].length;
            } catch (f) {
            }
            try {
                c += e.split(".")[1].length;
            } catch (f) {
            }
            try {
                return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
            } catch (error) {
            }
        },
        // 除
        div(a, b) {
            a = Number(a);
            b = Number(b);
            let c, d, e = 0,
                f = 0;
            try {
                e = a.toString().split(".")[1].length;
            } catch (g) {
            }
            try {
                f = b.toString().split(".")[1].length;
            } catch (g) {
            }
            return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(10, f - e));
        },
        is_empty(target) {
            try {
                if (target === undefined || target === null) {
                    return true;
                }

                // 分开处理空字符串，使其逻辑更清晰
                if (target === '') {
                    return true;
                }

                // 优化数字和字符串的检查，明确指出这些基本类型被认为是"非空"的
                if (typeof target === 'number' || typeof target === 'string') {
                    return false;
                }

                if (Array.isArray(target)) {
                    return target.length === 0;
                }

                if (typeof target === 'object') {
                    // 优化对象为空的检查，避免使用Object.keys增加性能开销
                    // 同时移除对null的检查，因为在前面已经通过==null进行了检查
                    return Object.prototype.toString.call(target) === '[object Object]' && !Object.keys(target).length;
                }
                // 对于未知类型，默认认为非空
                return false;
            } catch (error) {
                // 记录错误日志，以便于问题追踪和调试
                console.error("Error checking if target is empty:", error);
                // 根据实际情况，这里可以选择抛出异常或者返回特定的错误码，此处为了保持函数行为的一致性，选择返回false
                return false;
            }

        },


        // 订单状态判断
        order_state_decide(row) {
            // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完
            // send_state == 1 未发货 send_state == 2 部分发货 send_state == 3 全部发货  send_state == 4 已收货
            let {pay_state, send_state, company_check_state, platform_sale_check_state, contract_check_state} = row;

            if (company_check_state === '-1') {
                return createSafeSpan("用户取消", '')
            }
            if (platform_sale_check_state === '0') {
                return createSafeSpan("待销售审核", 'orange')
            }
            if (platform_sale_check_state === '-1') {
                return createSafeSpan("销售驳回", 'red')
            }
            if (contract_check_state === '0') {
                return createSafeSpan("待合同审核", 'orange')
            }
            if (contract_check_state === '-1') {
                return createSafeSpan("合同审核不通过", 'red')
            }

            if (pay_state === '0') {
                return createSafeSpan("待付款生产", 'red')
            }
            if (pay_state === '1') {
                return createSafeSpan("待付款发货", 'orange')
            }
            if (pay_state === '2' && send_state === '1') {
                return createSafeSpan("待发货", 'blue')
            }
            if (pay_state === '2') {
                return createSafeSpan("待货到付款", 'blue')
            }
            if (pay_state === '3' && send_state === '1') {
                return createSafeSpan("待发货", 'blue')
            }
            if (pay_state === '3' && send_state === '2' || pay_state === '3' && send_state === '3') {
                return createSafeSpan("待收货", "blue")
            }
            if (pay_state === '3' && send_state === '4') {
                return createSafeSpan("待评价", 'blue')
            }
            return createSafeSpan("已完成", 'green')

        },
        // 订单状态判断
        merchants_order_state_decide(row) {
            // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完
            // send_state == 1 未发货 send_state == 2 部分发货 send_state == 3 全部发货  send_state == 4 已收货

            if (row.check_state == '-1') {
                return `<span class="red">驳回指派</span>`
            }
            if (row.accept_state == '-1') {
                return `<span class="black">拒绝接单</span>`
            }
            if (row.check_state == '0') {
                return `<span class="orange">待审核</span>`
            }
            if (row.accept_state == '0') {
                return `<span class="orange">待接单</span>`
            }


            if (row.accept_state == '1' || row.send_state == '1') {
                return `<span class="red">生产中</span>`
            }
            if (row.accept_state == '1' && row.send_state == '2' || row.accept_state == '1' && row.send_state == '3') {
                return `<span class="orange">已发货</span>`
            }
            if (row.pay_state == '2' && row.send_state == '1') {
                return `<span class="blue">待发货</span>`
            }
            if (row.pay_state == '2') {
                return `<span class="blue">待货到付款</span>`
            }
            if (row.pay_state == '3' && row.send_state == '1') {
                return `<span class="blue">待发货</span>`
            }
            if (row.pay_state == '3' && row.send_state == '2' || row.pay_state == '3' && row.send_state == '3') {
                return `<span class="blue">待收货</span>`
            }
            if (row.pay_state == '3' && row.send_state == '4') {
                return `<span class="blue">待评价</span>`
            }

            return `<span class="green">已完成</span>`
        },
        // 订单状态判断
        order_state(row) {
            // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完
            // send_state == 1 未发货 send_state == 2 部分发货 send_state == 3 全部发货  send_state == 4 已收货

            if (row.company_check_state == '-1') {
                return `用户取消`
            }

            if (row.company_check_state == '1' && row.platform_sale_check_state == '-1') {
                return `销售驳回`
            }
            if (row.company_check_state == '1' && row.platform_sale_check_state == '0') {
                return `待销售审核`
            }
            if (row.company_check_state == '1' &&
                row.platform_sale_check_state == '1' &&
                row.contract_check_state == '-1') {
                return `合同审核未通过`
            }
            if (row.company_check_state == '1' &&
                row.platform_sale_check_state == '1' &&

                row.contract_check_state == '0') {
                return '待合同审核'
            }
            // if (row.company_check_state == '1' &&
            //     row.platform_sale_check_state == '1' &&
            //     row.company_check2_state == '0') {
            //     return '<span class="orange">待用户确认</span>'
            // }


            if (row.pay_state == '0') {
                return `待付款生产`
            }
            if (row.pay_state == '1') {
                return `待付款发货`
            }
            if (row.pay_state == '2' && row.send_state == '1') {
                return `待发货`
            }
            if (row.pay_state == '2') {
                return `待货到付款`
            }
            if (row.pay_state == '3' && row.send_state == '1') {
                return `待发货`
            }
            if (row.pay_state == '3' && row.send_state == '2' || row.pay_state == '3' && row.send_state == '3') {
                return `待收货`
            }
            if (row.pay_state == '3' && row.send_state == '4') {
                return `待评价`
            }

            return `已完成`
        },
        // 服务订单状态判断
        service_state_decide(row) {
            // pay_state == 0 待付款 pay_state == 1 已付第一笔  pay_state == 2  已付第二笔   pay_state == 3 已付完
            // private String company_check_state;//客户下单状态
            // private String platform_sale_check_state;//平台销售审核状态 -1:驳回 0:待审核 1:通过
            // private String platform_sale_check_time;//审核时间
            // private String technician_check_state;//技术接单
            // private String technician_assign_state;//指派技术状态
            // private String technician_assign_time;//指派技术时间
            // private String pay_state;//支付状态 0:未支付 1:已支付

            if (row.assessment_state === '1') {
                return "已完成"
            }
            if (row.company_check_state == '-1') {
                return "用户取消"
            }
            if (row.company_check_state == '1' && row.platform_sale_check_state == '-1') {
                return "销售驳回"
            }
            if (row.company_check_state == '1' && row.platform_sale_check_state == '0') {
                return "待销售审核"
            }
            if (row.company_check_state == '1' &&
                row.platform_sale_check_state == '1' &&
                row.contract_check_state == '-1') {
                return "合同审核不通过"
            }
            if (row.company_check_state == '1' &&
                row.platform_sale_check_state == '1' &&
                row.contract_check_state == '0') {
                return "待合同审核"
            }
            if (row.technician_assign_state == '0') {
                return "待指派订单"
            }
            if (row.technician_assign_state == '1') {
                return "已指派订单"
            }
            if (row.technician_check_state == '-1') {
                return "技术拒绝接单"
            }
            if (row.technician_check_state == '0') {
                return "待技术接单"
            }
            if (row.technician_check_state == '1') {
                return "技术已接单"
            }

            if (row.pay_state == '0') {
                return "待付款"
            }
            if (row.pay_state == '1') {
                return "已付款"
            }

        },
        // 发货状态判断
        send_state_show_text(state) {
            let obj = {
                1: "待发货",
                2: "部分发货",
                3: "已全部发货",
                4: "已收货"
            }
            return obj[state] || "状态未知";
        },
        // 发货状态判断
        send_state_show(state) {
            let obj = {
                1: createSafeSpan("待发货", "black"),
                2: createSafeSpan("部分发货", "orange"),
                3: createSafeSpan("已全部发货", "orange"),
                4: createSafeSpan("已收货", "blue")
            }
            return obj[state] || createSafeSpan("状态未知", "red");
        },
        // 渠道公关费用状态判断
        integral_state_show(state) {
            if (this.is_empty(state)) return createSafeSpan("已发起", "blue");
            let obj = {
                '-1': createSafeSpan("拒绝", "red"),
                0: createSafeSpan("申请中", "orange"),
                1: createSafeSpan("通过", "green"),
            }
            return obj[state] || createSafeSpan("状态未知", "red");
        },
        goods_type_show(type) {
            let obj = {
                1: "定制商品",
                2: "标准商品",
                3: "配件及维修设备"
            }
            return obj[type] || createSafeSpan("状态未知", "red");
        },
        // 是否打款状态判断
        is_pay_show(state) {
            let obj = {
                0: createSafeSpan("未兑换", "red"),
                1: createSafeSpan("已兑换", "green")
            }
            return obj[state] || createSafeSpan("状态未知", "red");
        },


        removeWordXml(text) {
            let html = text;
            html = html.replace(/<\/?SPANYES[^>]*>/gi, "");//  Remove  all  SPAN  tags
            // html = html.replace(/<(\w[^>]*)  class=([^|>]*)([^>]*)/gi, "<$1$3");  //  Remove  Class  attributes
            // html = html.replace(/<(\w[^>]*)  style="([^"]*)"([^>]*)/gi, "<$1$3");  //  Remove  Style  attributes
            html = html.replace(/<(\w[^>]*)  lang=([^|>]*)([^>]*)/gi, "<$1$3`   ");//  Remove  Lang  attributes
            html = html.replace(/<\\?\?xml[^>]*>/gi, "");//  Remove  XML  elements  and  declarations
            html = html.replace(/<\/?\w+:[^>]*>/gi, "");//  Remove  Tags  with  XML  namespace  declarations:  <o:p></o:p>
            html = html.replace(/&nbsp;/, "");//  Replace  the  &nbsp;
            html = html.replace(/\n(\n)*( )*(\n)*\n/gi, '\n');
            //  Transform  <P>  to  <DIV>
            // let  re  =  new  RegExp("(<P)([^>]*>.*?)(<//P>)","gi")  ;            //  Different  because  of  a  IE  5.0  error
            //        html = html.replace(re, "<div$2</div>");
            return html;
        },
        unique(arr) {
            if (!Array.isArray(arr)) {
                console.log('type error!')
                return
            }
            let array = [];
            let obj = {};
            for (let i = 0; i < arr.length; i++) {
                if (!this.is_empty(arr[i])) {
                    if (!obj[arr[i]]) {
                        array.push(arr[i])
                        obj[arr[i]] = 1
                    } else {
                        obj[arr[i]]++
                    }
                }
            }
            return array;
        },
        isJSON(str) {
            try {
                let s = JSON.parse(str);
                return s;
            } catch (error) {
                return false;
            }
        },
        formatDate(timestamp, fmt) {
            let time = timestamp;
            if (!time) {
                return "- -"
            }
            if (typeof time == 'string' && time.indexOf("T") === -1) {
                time = Date.parse(time.replace(/-/g, "/"));
            }

            if (typeof time == 'string') {
                time = new Date(Date.parse(time.replace(/-/g, "/")));　　　　　　　 // 将时间中的"-"替换为"/"，之所以这样是因为Date()构造函数只有2012/3/10这种形式实现浏览器全兼容。
            }
            let date = new Date(time);
            let o = {
                "M+": date.getMonth() + 1,//月份
                "d+": date.getDate(),//日
                "h+": date.getHours(),//小时
                "m+": date.getMinutes(),//分
                "s+": date.getSeconds(),//秒
                "q+": Math.floor((date.getMonth() + 3) / 3),//季度
                "S": date.getMilliseconds()//毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        },

        //字符串转为数组
        strToArr(str, key) {
            try {
                if (this.is_empty(key)) {
                    key = ',';
                }
                if (this.is_empty(str)) return [];
                return str.toString().split(key)
            } catch (err) {
                return [];
            }
        },
        //数组转为字符串
        arrToStr(arr, key) {
            try {
                if (this.is_empty(key)) {
                    key = ',';
                }
                if (this.is_empty(arr)) return "";
                return arr.join(key)
            } catch (err) {
                return "";
            }
        },





        companyState(state) {
            state = Number(state);

            if (state === 0) {
                return "<span class='orange'>待审核</span>";
            } else if (state === 1) {
                return "<span class='green'>审核通过</span>";
            } else if (state === 2) {
                return "<span class='red'>拒绝</span>";
            }
        },
        check_state_show(v) {
            let obj = {
                "-1": '<span class="red">未通过</span>',
                "0": "<span class='orange'>待审核</span>",
                "1": "<span class='green'>已通过</span>",
            }
            return obj[v] || '未申请'
        },

    },
    filters: {
        feedback_type_show(v) {
            switch (v + '') {
                case "1":
                    return "客户反馈到平台"
                    break;
                case "2":
                    return "平台反馈到供应商"
                    break;
                default:
                    return "";
                    break;
            }
        },
        pay_state_show(v) {
            switch (Number(v)) {
                case -1:
                    return "已作废"
                    break;
                case 0:
                    return "未支付"
                    break;
                case 1:
                    return "已支付"
                    break;
                default:
                    return "";
                    break;
            }
        },




        order_contract_template(v) {
            switch (v) {
                case "yifa":
                    return "益发合同";
                case "kaiyao":
                    return "凯耀合同";
                default:
                    return ""
            }
        },

    }
};

Vue.mixin(myMixin);